import { render, staticRenderFns } from "./PurchaseEvaluation.vue?vue&type=template&id=36ae70df&scoped=true&"
import script from "./PurchaseEvaluation.vue?vue&type=script&lang=js&"
export * from "./PurchaseEvaluation.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseEvaluation.vue?vue&type=style&index=0&id=36ae70df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ae70df",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCard,VSelect})
